import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import Switch from "react-switch";
import Alert from "react-s-alert";
import moment from "moment";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import {
  admin_update_sms_templates,
  admin_update_email_templates,
  admin_update_notification_templates,
} from "../../../../../store/actions/SuperAdminActions/adminTemplatesAction";

export class ToggleButtonPopup extends Component {
  constructor(props) {
    super();
    this.state = {
      open: false,
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  };
  onCloseModal = () => {
    this.setState({ open: false });
  };

  onYesButtonClick = (templateData, actionBy) => (e) => {
    console.log(actionBy);
    var currentDate = moment().format("YYYY-MM-DD");
    var endDate = moment(templateData.endDate).format("YYYY-MM-DD");
    const formData = {
      status: templateData.status === true ? false : true,
    };
    if (currentDate > endDate) {
      Alert.error(
        `<h4>You can not change the status, because SMS Template expired</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        }
      );
      this.onCloseModal();
    } else if (currentDate <= endDate) {
      if (actionBy === "SMS") {
        this.props.admin_update_sms_templates(
          templateData._id,
          this.props.auth.user.accessToken,
          formData,
          this.onSuccess(actionBy)
        );
      } else if (actionBy === "EMAIL") {
        this.props.admin_update_email_templates(
          templateData._id,
          this.props.auth.user.accessToken,
          formData,
          this.onSuccess(actionBy)
        );
      } else if (actionBy === "NOTIFICATION") {
        this.props.admin_update_notification_templates(
          templateData._id,
          this.props.auth.user.accessToken,
          formData,
          this.onSuccess(actionBy)
        );
      }
    }
  };

  onSuccess = (actionBy) => (e) => {
    this.onCloseModal();
    Alert.success(
      `<h4>${
        actionBy === "SMS"
          ? "SMS"
          : actionBy === "EMAIL"
          ? "Email"
          : actionBy === "NOTIFICATION"
          ? "Notification"
          : ""
      } Template Status Update Successfully</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };

  render() {
    const { open } = this.state;
    return (
      <React.Fragment>
        <Switch
          checked={this.props.activeProps.status}
          // onChange={this.onOpenModal}
          onChange={() => console.log()}
          offColor="#EEEEEE"
          onColor="#EEEEEE"
          offHandleColor="#212121"
          onHandleColor="#59F832"
          handleDiameter={this.props.diameter} //19
          uncheckedIcon={false}
          checkedIcon={false}
          offColor="#bcbcbc"
          boxShadow="-2px 0px 5px #0000003B"
          activeBoxShadow="-2px 0px 5px #0000003B"
          height={this.props.height} //22
          width={this.props.width} //45
          id="disabled-switch"
          disabled
        />
        <Modal show={open} onHide={this.onCloseModal} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure you want to change the status
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={this.onCloseModal}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              onClick={this.onYesButtonClick(
                this.props.activeProps,
                this.props.actionBy
              )}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

ToggleButtonPopup.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  admin_update_sms_templates: PropTypes.func.isRequired,
  admin_update_email_templates: PropTypes.func.isRequired,
  admin_update_notification_templates: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  admin_update_sms_templates,
  admin_update_email_templates,
  admin_update_notification_templates,
})(withRouter(ToggleButtonPopup));
